<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="addressIpt" size="mini" style="width:150px" placeholder="请输入委托商"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="customerName" label="委托商" align="center"/>
          <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="model" label="型号" align="center"/>
          <el-table-column prop="config" label="配置" align="center"/>
          <el-table-column prop="weight" label="重量" align="center"/>
          <el-table-column prop="volume" label="长x宽x高" align="center"/>
          <el-table-column prop="stateStr" label="状态" align="center"/>
          <el-table-column label="操作" width="270" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button v-if="scope.row.status" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="addressData" label-width="95px" :rules="rules" ref="ruleForm">
          <el-form-item label="委托商名称：" prop="customerName">
            <el-select v-model="addressData.customerName" filterable size="mini" style="width:100%" placeholder="请选择委托商名称" value-key="id">
              <el-option v-for="item in typeOption" :key="item.id" :label="item.customer_name" :value="item"/>
            </el-select>
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="品牌：" prop="brand">
            <el-input
              :style="'width:100%'"
              v-model="addressData.brand"
              placeholder="请输入品牌"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="型号：" prop="model">
            <el-input
              :style="'width:100%'"
              v-model="addressData.model"
              placeholder="请输入型号"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="配置：" prop="config">
            <el-input
              :style="'width:100%'"
              v-model="addressData.config"
              placeholder="请输入配置"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="重量：" prop="weight">
            <el-input
              :style="'width:100%'"
              v-model="addressData.weight"
              placeholder="请输入重量"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="长宽高：" prop="volume">
            <el-input
              :style="'width:100%'"
              v-model="addressData.volume"
              placeholder="请输入长宽高"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <div class="btnContainer">
            <el-button class="searchBtn" size="medium" :loading="addLoad" @click="addClick">添加</el-button>
            <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="详情委托商类型" :visible.sync="detailDialogVisible" width='550px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="getStyle(detailData.status)">{{detailData.stateStr}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">委托商：</span>
              <span>{{detailData.customerName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">品牌：</span>
              <span>{{detailData.brand}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">型号：</span>
              <span>{{detailData.model}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">配置：</span>
              <span>{{detailData.config}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">重量：</span>
              <span>{{detailData.weight}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">长x宽x高：</span>
              <span>{{detailData.volume}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  customerCarInfoPageList,
  customerCarInfoIsEnable,
  customerCarInfoDetail,
  customerCarInfoAdd,
  customerCarInfoUpdate,
  customerCarInfoDelete,
} from "@/service/basicfile"
import {customerInfoSelectList} from "@/service/getData"
import {formatDateTime} from "@/config/mUtils";

export default {
  components: {
  },

  data() {
    return {
      addressIpt:'',
      stateIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'启动中',},
        {value:2,label:'禁用中',},
      ],
      typeOption:[],
      tableLoad:false,
      TableDatas:[],
      detailData:{state:'启动中',name:'123123123',remark:'重庆市-渝北区',},
      operationData:[
        {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
      ],
      page:1,
      size:10,
      total:0,
      dialogTitle:'',
      dialogVisible:false,
      detailDialogVisible:false,
      addLoad:false,
      addressData:{},
      rules:{
        customerName:[
          { required: true, message: '请选择委托商名称', trigger: 'change' },
        ],
        brand:[
          { required: true, message: '请输入品牌', trigger: 'blur' },
        ],
        model:[
          { required: true, message: '请输入型号', trigger: 'blur' },
        ],
        config:[
          { required: true, message: '请输入配置', trigger: 'blur' },
        ],
        weight:[
          { required: true, message: '请输入重量', trigger: 'blur' },
        ],
        volume:[
          { required: true, message: '长宽高', trigger: 'blur' },
        ],
      },
    };
  },
  computed:{
    getStyle() {
      return (val) => {
        switch (val) {
          case 1:
            return 'color: rgba(249, 166, 6, 1)'
          case 0:
            return 'color:#F56C6C;'
        }
      }
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init(){
      await this._customerCarInfoPageList();
      const res = await customerInfoSelectList();
      if(res.status !== 0) this.$message.error(res.message);
      else this.typeOption=res.data;
    },
    async _customerCarInfoPageList(){
      this.tableLoad=true;
      const obj={
        customerName:this.addressIpt,
        status:this.stateIpt,
        rows:this.size,
        age:this.page,
      };
      const res = await customerCarInfoPageList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    resetBtn(){
      this.addressIpt='';
      this.stateIpt='';
    },
    searchBtn(){
      this.page = 1;
      this._customerCarInfoPageList();
    },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='新增委托车';
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._customerCarInfoPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._customerCarInfoPageList();
    },
    disableClick(id){
      this.$confirm('确定要禁用当前委托车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await customerCarInfoIsEnable(id)
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._customerCarInfoPageList();
      }).catch(() => {});
    },
    enableClick(id){
      this.$confirm('确定要启用当前委托车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await customerCarInfoIsEnable(id)
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._customerCarInfoPageList();
      }).catch(() => {});
    },
    async detailClick(id) {
      const res = await customerCarInfoDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData={
        ...res.data,
      };
      this.operationData=res.data.operateRecordList;
      this.detailDialogVisible = true;
    },
    changeClick(item){
      this.addressData={
        ...item,
      };
      this.dialogVisible=true;
      this.dialogTitle='修改委托车信息';
    },
    dialogClose(){
      this.dialogVisible=false;
      this.addressData={};
      this.$refs.ruleForm.resetFields();
    },
    addClick(){
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.addLoad = true;
          const obj={
            ...this.addressData,
            customerId:this.addressData.customerName.id,
            customerName:this.addressData.customerName.customer_name,
          };
          const res = this.dialogTitle==='新增委托车'?await customerCarInfoAdd(obj):await customerCarInfoUpdate(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this._customerCarInfoPageList();
          this.dialogVisible=false;
        } else return false;
      });
    },
    deleteClick(id){
      this.$confirm('确定要删除当前委托车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await customerCarInfoDelete(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._customerCarInfoPageList();
      }).catch(() => {});
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .permissions{
    width:100%;
    padding: 20px 10px 20px 50px;
    .name{
      display:flex;
      align-items:center;
      margin-bottom: 20px;
      span{
        color: #2F1010;
      }
    }
    .content1{
      p{
        color: #2F1010;
      }
    }
    .tree{
      border:1px solid #D2D2D2;
      width: 400px;
      height: 280px;
      margin-left: 60px;
      border-radius: 5px;
      padding:5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
